import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import IntegrationCard from "../../components/IntegrationCard";
import { saCard } from "../../components/saShared";

const CHANNEL_LABELS = { email: "Email", sms: "SMS", whatsapp: "WhatsApp", whatsapp_api: "WhatsApp API", stripe: "Stripe" };

export default function SAIntegrazioni() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setError(false);
    api.get("/superadmin/integrations").then((r) => setData(r.data)).catch(() => setError(true));
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggleMode = async (key, mode) => {
    const current = data.allowed_modes[key] || ["dishenda", "ristorante"];
    const next = current.includes(mode) ? current.filter((m) => m !== mode) : [...current, mode];
    if (next.length === 0) { toast.error("Almeno una modalità deve restare attiva"); return; }
    try {
      await api.patch("/superadmin/integrations/modes", { allowed_modes: { ...data.allowed_modes, [key]: next } });
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-5 max-w-3xl" data-testid="sa-integrazioni">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">Integrazioni globali</h1>
        <p className="text-xs text-zinc-500">Provider della piattaforma Dishenda. Modalità MOCK: nessuna chiamata reale a Stripe/Twilio/Resend/SES.</p>
      </div>

      <section className={`${saCard} p-4`} data-testid="sa-modes">
        <h2 className="text-[10px] font-semibold uppercase tracking-wider text-zinc-500 mb-3">Modalità consentite ai ristoranti</h2>
        <div className="space-y-2">
          {Object.entries(CHANNEL_LABELS).map(([key, label]) => {
            const modes = data?.allowed_modes?.[key] || ["dishenda", "ristorante"];
            return (
              <div key={key} className="flex items-center gap-3 flex-wrap text-sm">
                <span className="w-36 text-zinc-300 font-medium">{label}</span>
                {[["dishenda", "Provider Dishenda"], ["ristorante", "Provider del ristorante"]].map(([mode, ml]) => (
                  <button key={mode} onClick={() => toggleMode(key, mode)} data-testid={`mode-${key}-${mode}`}
                    className={`h-8 px-3 rounded-full text-[11px] font-bold border transition ${
                      modes.includes(mode) ? "bg-amber-400 text-zinc-950 border-amber-400" : "bg-zinc-800 text-zinc-500 border-zinc-700"}`}>
                    {ml}
                  </button>
                ))}
              </div>
            );
          })}
        </div>
      </section>

      {!data && !error && <div className="text-sm text-zinc-500 py-8 text-center" data-testid="sa-integrazioni-loading">Caricamento...</div>}
      {error && (
        <div className="bg-rose-500/10 border border-rose-500/40 rounded-lg p-6 text-center" data-testid="sa-integrazioni-error">
          <p className="text-sm text-rose-300 mb-3">Errore nel caricamento delle integrazioni</p>
          <button onClick={load} className="h-9 px-4 rounded-md bg-amber-400 text-zinc-950 text-xs font-bold">Riprova</button>
        </div>
      )}

      <div className="space-y-3" data-testid="sa-integrations-list">
        {data?.integrations.map((item) => (
          <IntegrationCard key={item.key} item={item} basePath="/superadmin" onChanged={load} allowedModes={data.allowed_modes} dark />
        ))}
      </div>
    </div>
  );
}
